import { useEffect, useState } from 'react'
import { mtc } from '@/styles'
import type { OperatorIdentity } from '@/features/adviser-chat/lib/types'

interface OperatorAvatarProps {
  operator: OperatorIdentity | null
  className?: string
}

export const OperatorAvatar = ({
  operator,
  className,
}: OperatorAvatarProps) => {
  const [avatarFailed, setAvatarFailed] = useState(false)
  const avatarUrl = operator?.avatarUrl

  useEffect(() => setAvatarFailed(false), [avatarUrl])

  return (
    <div
      className={mtc(
        'flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-moss-50 text-xs text-moss-600',
        className
      )}
    >
      {avatarUrl && !avatarFailed ? (
        <img
          src={avatarUrl}
          alt=""
          className="size-full object-cover"
          onError={() => setAvatarFailed(true)}
        />
      ) : (
        (operator?.friendlyName || 'Heard').charAt(0).toUpperCase()
      )}
    </div>
  )
}
